<template>
  <div class="seomain">
		<st-header
		  :title="mode == 0 ? 'SZ出库记录' : 'HK出库记录'"
		  :back-able="true"
		>
		  <template slot="header-right">
				<span class="search-icon-span">
					<!-- <van-icon name="search" @click="showSearch = true"/> -->
				</span>
		  </template>
		</st-header>
   
    <div class="tab-content tab-content-list">
			<!-- 搜索 多行 -->
			<div class="keyword">
        <div class="keyword-panel" v-if="showSearch">
          <div class="keyword-panel-head">
            <span class="keyword-panel-title">搜索筛选</span>
            <span class="keyword-panel-close" @click="showSearch = false">
              <van-icon name="cross" />
            </span>
          </div>
          <van-form class="keyword-form" @submit="submitKeyword">
            <van-field v-model="searchData.order_code" label="单号" placeholder="请输入单号" />
            <van-field v-model="searchData.sku" label="SKU" placeholder="请输入SKU" />
            <div class="keyword-form-actions keyword-form-actions-split">
              <button class="clearBtn" type="button" @click="clearSearch">清空条件</button>
              <button class="submitBtn" type="submit">搜 索</button>
            </div>
          </van-form>
        </div>
        <div class="keyword-collapsed" v-else @click="showSearch = true">
          <van-icon name="search" />
          <span>搜索单号 / SKU</span>
        </div>
			</div>
			
      <div class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
            <router-link :to="getOrderDetailRoute(v)" class="st-list-top st-list-top-with-qty">
              <div class="t-tit">{{ v.sales_order }}</div>
              <div class="t-qty">{{ getTotalOutstock(v) }}</div>
            </router-link>
            <div class="st-list-main">
              <div class="st-field"><span class="st-field-label">批次号</span><span class="st-field-value">{{ v.batch || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">操作人</span><span class="st-field-value">{{ v.operater || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">出库时间</span><span class="st-field-value">{{ v.createtime_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">备注</span><span class="st-field-value">{{ v.remark || '--' }}</span></div>
              <div class="st-sku-panel">
                <div class="st-sku-panel-title">SKU明细</div>
                <div :class="['st-sku-list', skuShowAll[v.id] ? '' : 'sku-show-part']">
                  <div class="st-sku-card" v-for="(vv, i) in v.list" :key="vv.id || i">
                    <div class="st-sku-main">
                      <div class="st-sku-name">{{ vv.sku || '--' }}</div>
                      <div class="st-sku-warehouse">{{ vv.warehouse || '--' }}</div>
                    </div>
                    <div class="st-sku-qty">{{ vv.outstocknum || '--' }}</div>
                  </div>
                  <div class="sku-extend-btn" @click="openSku(v.id)">展开更多</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
		"st-header": StHeader,
	},
  props: {},
  data() {
    return {
			loading: false,
			finished: false,
			page: 1,
			skuShowAll: {},
			showSearch: false,
			searchData: {
				order_code: "",
				sku: "",
				id: "",
			},
			stlist: [],
			mode: this.$route.params.mode,
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list() {
      this.stlist = [];
      this.onLoad();
    },
    init() {
			this.searchData.id = this.$route.params.id;
			this.get_st_list();
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let params = this.searchData;
			params['page'] = this.page;
			params['type'] = this.mode;
      let result = await this.$post(this.$api.stGetFaHuoOutlog, params);
			setTimeout(() => {}, 2000)
      if (result.data.length == 0) return (this.finished = true);
			result.data.forEach((item) => {
				if (item.list.length > 3) {
					this.skuShowAll[item.id] = false;
				} else {
					this.skuShowAll[item.id] = true;
				}
			});
      // 进行操作
      this.stlist.push(...result.data);
      // 操作完成
			this.page += 1;
      this.loading = false;
    },
    
    goUrl(url) {
      this.$router.push(url);
      return;
    },
    getOrderDetailRoute(item) {
      const orderId = (item && item.sales_order_id) ? item.sales_order_id : this.$route.params.mode;
      const type = this.$route.query && this.$route.query.type;
      if (type === '1' || type === '0') {
        return `/saleo/detail/${orderId}?type=${type}`;
      }
      return `/saleo/detail/${orderId}`;
    },
    getTotalOutstock(item) {
      const list = (item && item.list) || [];
      return list.reduce((sum, cur) => sum + Number((cur && cur.outstocknum) || 0), 0);
    },
    
    onSearch() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    clearSearch() {
      this.searchData.order_code = "";
      this.searchData.sku = "";
      this.$toast("已清空搜索条件");
    },
    // 关键字搜索
    submitKeyword() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
		// 展开sku列表
		openSku(id) {
			this.$set(this.skuShowAll, id, true);
			this.$forceUpdate();
		}
  },
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}
.keyword {
  position: relative;
	top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 8px;
  margin-top: 40px;
  margin-bottom: 0;
}

.tab-content-list {
  padding-top: 0;
	position: relative;
	top:0;
}

.st-list-box {
  margin: 12px 24px 10px;
  .st-list {
    border-radius: 5px;
  }
}

.keyword-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
}

.keyword-panel-head {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f7;
}

.keyword-panel-title {
  font-size: 14px;
  color: #5c6575;
  font-weight: 600;
}

.keyword-panel-close {
  color: #8a93a3;
  font-size: 18px;
  line-height: 1;
}

.keyword-form {
  margin: 0;
}

.keyword-form-actions {
  padding: 12px;
  background-color: #fff;
}

.keyword-form-actions-split {
  display: flex;
  gap: 12px;
}

.keyword-form-actions-split .clearBtn,
.keyword-form-actions-split .submitBtn {
  flex: 1;
  height: 36px;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  outline: none;
}

.keyword-form-actions-split .clearBtn {
  background: #677588;
}

.keyword-form-actions-split .submitBtn {
  background: #00baad;
}

.keyword-collapsed {
  margin: 0 12px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  color: #8b95a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #eceff5;
  box-shadow: none;
}

.st-list-top-with-qty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.st-list-top-with-qty .t-tit {
  flex: 1;
  min-width: 0;
}

.st-list-top-with-qty .t-qty {
  flex: 0 0 auto;
  color: #2a9df4;
  font-size: 16px;
  font-weight: 700;
}

.st-list-main {
  padding-top: 4px;
  padding-bottom: 4px;
}

.st-field {
  display: flex;
  align-items: flex-start;
  padding: 6px 0;
  font-size: 14px;
  line-height: 1.5;
  border-bottom: 1px dashed #f1f3f7;
}

.st-field-label {
  flex: 0 0 84px;
  color: #7d8697;
}

.st-field-label::after {
  content: "：";
}

.st-field-value {
  flex: 1;
  min-width: 0;
  color: #394150;
  word-break: break-all;
}

.st-sku-panel {
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  background: #f7f9fc;
}

.st-sku-panel-title {
  margin-bottom: 10px;
  color: #5f6878;
  font-size: 13px;
  font-weight: 600;
}

.st-sku-list {
  position: relative;
}

.st-sku-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: #fff;
}

.st-sku-card:last-child {
  margin-bottom: 0;
}

.st-sku-main {
  flex: 1;
  min-width: 0;
}

.st-sku-name {
  color: #2f3747;
  font-weight: 600;
  word-break: break-all;
}

.st-sku-warehouse {
  margin-top: 4px;
  color: #8b95a7;
  font-size: 12px;
}

.st-sku-qty {
  flex: 0 0 auto;
  color: #2a9df4;
  font-size: 18px;
  font-weight: 700;
}

.sku-extend-btn {
  display: none;
}

.sku-show-part {
  max-height: 188px;
  overflow: hidden;
  position: relative;
}

.sku-show-part .sku-extend-btn {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #7c8798;
  font-size: 13px;
  background: linear-gradient(180deg, rgba(247, 249, 252, 0) 0%, #f7f9fc 55%);
}
</style>
